import { useState } from 'react';

import { onCloseInfoBanner } from './actions';
import { getBannerCookieName } from './banner-helper';

function getClientSideCookieValue(id: string): boolean {
    if (typeof window === 'undefined') return false;

    const cookies = document.cookie.split(';');
    const bannerCookie = cookies.find((cookie) => cookie.trim().startsWith(`${getBannerCookieName(id)}=`));
    return bannerCookie?.split('=')[1] === 'closed';
}

export function useInfoBanner(id: string) {
    // Initialize with client-side cookie check during first render
    const [isClosed, setIsClosed] = useState<boolean>(() => {
        return getClientSideCookieValue(id);
    });

    function close() {
        // Set cookie client-side immediately for instant feedback
        if (typeof window !== 'undefined') {
            document.cookie = `${getBannerCookieName(id)}=closed; path=/; max-age=31536000`; // 1 year
        }
        setIsClosed(true);

        // Also update server-side
        onCloseInfoBanner(id).then();
    }

    return {
        close: close,
        isClosed: isClosed,
        isLoading: false // No loading state needed anymore
    };
}
